module.exports = __webpack_public_path__ + "img/gold1.7d84814b.png";